import { combineReducers } from 'redux'
import all from './all'
import byNode from './byNode'


export default combineReducers({ all, byNode })
